import { SubscriptionCard } from '@/components/Cards/SubscriptionCard/SubscriptionCard';
import { useOrganizationStore } from '@/stores/organizationStore';
import { Price, StripeSubscription } from '@/types/Stripe';
import { Flex, Text, Title } from '@tremor/react';
import { useLoaderData } from 'react-router-dom';
import s from './Subscriptions.module.scss';
// import { useState } from 'react';
// import ReactSwitch from 'react-switch';
// import classNames from 'classnames';
import { fetchActiveProductsWithPrices } from '@/services/stripeService';
import { useMemo, useState } from 'react';
import { PopupModal } from 'react-calendly';

type StripeSubscriptionWithoutRecurring = Omit<StripeSubscription, 'prices'> & {
  prices: Omit<Price, 'recurring'>[];
};

type noSub = { isNotSub?: boolean };

const enterpriseSubscription: StripeSubscriptionWithoutRecurring & noSub = {
  id: 'enterprise',
  name: 'Enterprise',
  description: 'Custom plan for large organizations',
  active: true,
  isNotSub: true,
  marketing_features: [
    { name: 'Unlimited workspaces' },
    { name: 'Access to all data sources' },
    { name: 'Monitor unlimited keywords' },
    { name: 'Built-in SSOT marketing and search visibility dashboards' },
    { name: 'Custom reports and dashboards' },
    { name: 'Custom data models' },
    { name: 'Connection to your own DWH' },
    { name: 'Connection to your own BI and data visualization tools' },
    {
      name: 'Custom instance, using your branding, separate user management rules, etc.',
    },
    { name: '(Optional) Deployment in your own Google Cloud Platform project' },
  ],
  role: 'ENTERPRISE',
  images: [],
  metadata: {},
  tax_code: null,
  prices: [
    {
      currency: 'usd',
      type: 'one_time',
      unit_amount: 0,
      active: true,
      id: 'enterprise_price',
      description: null,
      billing_scheme: 'per_unit',
      product: 'enterprise_product',
      trial_period_days: null,
      transform_quantity: null,
      tiers: null,
      tiers_mode: null,
      interval: 'year',
      tax_behavior: 'exclusive',
      metadata: {},
      interval_count: 1,
    },
  ],
};

export function Subscriptions() {
  const data = useLoaderData() as (StripeSubscription & noSub)[];
  const filteredData = data.filter((sub) => sub.prices.length !== 0);
  const [isOpen, setIsOpen] = useState(false);
  const enhancedData = useMemo(() => {
    if (import.meta.env._VITE_SHOW_CUSTOM_SUBSCRIPTION_TIER === 'true')
      return [...filteredData, enterpriseSubscription];
    else return filteredData;
  }, [filteredData]);
  const organizationId = useOrganizationStore((state) => state.selectedOrganization?.id);
  // const [billingPeriod, setBillingPeriod] = useState<'yearly' | 'monthly'>('yearly');
  return (
    <Flex flexDirection="col" className={s.mainWrapper} justifyContent="center">
      <div>
        <Title className={s.title}>Choose the right plan for you</Title>
      </div>
      {/* <Flex justifyContent="center" className={s.switchContainer}>
        <Text
          className={classNames(s.billingPeriodTexts, {
            [s.activeBillingPeriod]: billingPeriod === 'monthly',
          })}
        >
          Monthly
        </Text>
        <ReactSwitch
          handleDiameter={16}
          height={24}
          width={42}
          onColor="#ba2634"
          offColor="#cbcfd6"
          checkedIcon={false}
          uncheckedIcon={false}
          checked={billingPeriod === 'yearly'}
          onChange={() => {
            setBillingPeriod((state) => (state === 'monthly' ? 'yearly' : 'monthly'));
          }}
        />
        <Text
          className={classNames(s.billingPeriodTexts, {
            [s.activeBillingPeriod]: billingPeriod === 'yearly',
          })}
        >
          Annual <span className={s.saveText}>(Save 20%)</span>
        </Text>
      </Flex> */}
      <Flex className={s.container} justifyContent="center" alignItems="center">
        {enhancedData.map((product, i) => (
          <SubscriptionCard
            features={product.marketing_features}
            key={product.id}
            currency={product.prices[0]?.currency}
            description={product.description}
            mode={product.prices[0].type === 'one_time' ? 'payment' : 'subscription'}
            name={product.name}
            organizationId={organizationId as string}
            price={product.prices[0]?.unit_amount}
            priceId={product.prices[0].id}
            isMostBought={(i + 1) % 2 === 0}
            isNotSub={product.isNotSub}
          />
        ))}
      </Flex>
      <Text className={s.conactUs}>
        Need a custom plan?
        <button className={s.contactUsLink} onClick={() => setIsOpen(true)}>
          Contact us
        </button>
      </Text>
      <PopupModal
        url="https://calendly.com/defuseddata-maciek/marchemy-demo"
        onModalClose={() => setIsOpen(false)}
        open={isOpen}
        rootElement={document.getElementById('root') as HTMLElement}
      />
    </Flex>
  );
}

export async function subscriptionsLoader() {
  return fetchActiveProductsWithPrices();
}
